// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"108":"0b980ad5","404":"6d316230","409":"33dee81e","424":"c28708c3","461":"301c982b","604":"af116b11","631":"9abefa0e","656":"e0c576af","695":"0484d9e1"}[chunkId] + ".chunk.css";
};